import { ApiHelper, ApiHelperWithData, ApiResponseWithData, BaseRequest, splitParams } from '..';
import { FuncReqDef, FuncReqDef_Params } from '../model';

export class FuncReqDefApi {
  private withData: ApiHelperWithData;
  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  /**
   * 기능 요구사항 정의서 목록 조회
   */
  list = (params: BaseRequest): Promise<ApiResponseWithData<{ list: FuncReqDef[] }>> => {
    const url = '/apis/func-req-def/list';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 기능 요구사항 정의서 단건 조회
   */
  info = (
    params: { defNo: number } & BaseRequest,
  ): Promise<ApiResponseWithData<{ info: FuncReqDef }>> => {
    const url = '/apis/func-req-def/info';
    return this.withData.post(url, ...splitParams(params));
  };

  /**
   * 기능 요구사항 정의서 등록
   */
  create = (
    params: FuncReqDef_Params & BaseRequest,
  ): Promise<ApiResponseWithData<{ instCnt: number }>> => {
    const url = '/apis/func-req-def/create';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 기능 요구사항 정의서 수정
   */
  update = (
    params: FuncReqDef_Params & BaseRequest,
  ): Promise<ApiResponseWithData<{ uptCnt: number }>> => {
    const url = '/apis/func-req-def/update';
    return this.withData.postJson(url, ...splitParams(params));
  };
}
